import { Product } from '../types';

export function getProductDisplayPrice(product: Product | null | undefined): {
  isFlashActive: boolean;
  displayPrice: number;
  originalPrice: number;
  discountPercent: number;
} {
  if (!product) {
    return { isFlashActive: false, displayPrice: 0, originalPrice: 0, discountPercent: 0 };
  }

  const isFlashToggle = Boolean(product.is_flash_sale || (product as any).flashSaleActive);
  const endDateStr = product.flash_sale_end_date || (product as any).flashSaleEndTime;
  
  let isTimeValid = true;
  if (endDateStr) {
    const endDate = new Date(endDateStr);
    if (!isNaN(endDate.getTime()) && new Date() >= endDate) {
      isTimeValid = false;
    }
  }

  const rawFlashPrice = product.flashPrice ?? (product as any).flashSalePrice;
  const hasFlashPrice = rawFlashPrice !== undefined && rawFlashPrice !== null && Number(rawFlashPrice) > 0;

  const isFlashActive = isFlashToggle && isTimeValid && hasFlashPrice;

  const basePrice = Number(product.price) || 0;
  const regPrice = Number(product.regularPrice) || 0;

  let displayPrice = basePrice;
  let originalPrice = regPrice > basePrice ? regPrice : (basePrice > 0 ? Math.round(basePrice * 1.3) : 0);

  if (isFlashActive) {
    displayPrice = Number(rawFlashPrice);
    originalPrice = regPrice > displayPrice ? regPrice : (basePrice > displayPrice ? basePrice : Math.round(displayPrice * 1.3));
  }

  const savingAmt = originalPrice > displayPrice ? originalPrice - displayPrice : 0;
  const discountPercent = originalPrice > 0 ? Math.round((savingAmt / originalPrice) * 100) : 0;

  return {
    isFlashActive,
    displayPrice,
    originalPrice,
    discountPercent
  };
}
